import { DataTable } from "@msuite/ui/table";
import { moment } from "@msuite/utils/date";
import type { UserPanelBaseProps } from "../types";
import { columns } from "./table-config";
import { useUserAttendances } from "./use-user-attendances";
import { UserAttendancesMenu } from "./user-attendances-menu";

export function UserAttendances({ userId }: UserPanelBaseProps) {
	/** Query */
	const { attendances, isLoading, queryKey, refetch } = useUserAttendances(userId);

	/** Render */
	return (
		<DataTable
			data={attendances}
			columns={columns}
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			grouping={["date"]}
			renderGroupHeader={(row) => {
				return <p>{moment(row.original.startTime).dateFormat()}</p>;
			}}
			initialShowGroupingHeader
			persistenceKey="user-attendances-table"
			menu={<UserAttendancesMenu userId={userId} />}
		/>
	);
}
